module.exports = __webpack_public_path__ + "img/whatsuppdoodlee.af6ce311.png";